import { useLayoutEffect, useRef, useState } from "react";
import { useWindowSize } from "react-use";
import {
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
  List as VirtualizedList,
  WindowScroller,
} from "react-virtualized";

import { Divider, Paper } from "@mui/material";

import { ApiRoutesItem } from "@/api/routes";
import { ProInfoUseInRoute } from "@/components/ProInfo";
import { useGlobalStoreContext } from "@/context/globalStoreContext";
import usePlatform from "@/hooks/usePlatform";
import useRoutesTooltipIdentify from "@/hooks/useRoutesTooltipIdentify";
import BannerCard from "@/pages/FlightSearch/BannerCard";
import { CabinsType } from "@/typings";

import RoutesItem from "../RoutesItem";
import { SHOW_BANNER_CARD } from "@/constants/membership";

const RoutesList = (props: {
  refreshIds: string[];
  data: ApiRoutesItem[];
  onClick: (
    v: ApiRoutesItem & {
      type: CabinsType;
    }
  ) => void;
}) => {
  const cacheRef = useRef(
    new CellMeasurerCache({
      fixedWidth: true,
      minHeight: 50,
    })
  );

  const { width: windowWidth } = useWindowSize();

  const store = useGlobalStoreContext();
  const show_upsell: boolean = store?.show_upsell;
  const { isPc } = usePlatform();
  const { hideRoutesTooltip, routesTooltipIdentifyVisible } = useRoutesTooltipIdentify();

  useLayoutEffect(() => {
    cacheRef.current.clearAll();
  }, [windowWidth]);

  return (
    <Paper elevation={1}>
      <WindowScroller scrollElement={window}>
        {({ height, isScrolling, registerChild, onChildScroll, scrollTop }) => (
          <AutoSizer disableHeight>
            {({ width }) => (
              // @ts-ignore
              <div ref={registerChild}>
                <VirtualizedList
                  ref={(el) => {
                    // @ts-ignore
                    window.listEl = el;
                  }}
                  autoHeight
                  isScrolling={isScrolling}
                  onScroll={onChildScroll}
                  scrollTop={scrollTop}
                  deferredMeasurementCache={cacheRef.current}
                  rowCount={props.data.length}
                  rowRenderer={({ index, key, parent, style }) => (
                    <CellMeasurer
                      cache={cacheRef.current}
                      columnIndex={0}
                      key={key}
                      rowIndex={index}
                      parent={parent}
                    >
                      {({ measure, registerChild }) => (
                        // @ts-ignore
                        <div ref={registerChild} style={style} key={index}>
                          <RoutesItem
                            onLoad={measure}
                            data={props.data[index]}
                            onClick={props.onClick}
                            showToolTip={index === 0 && routesTooltipIdentifyVisible && isPc}
                            onCloseToolTip={() => hideRoutesTooltip()}
                            refreshing={props.refreshIds.includes(props.data[index].id)}
                          />
                          {index < props.data.length - 1 ? <Divider /> : null}

                          {show_upsell && (
                            <>
                              {((props.data.length > 3 && index === 2) ||
                                (props.data.length < 3 && index == props.data.length - 1)) && (
                                <>
                                  <ProInfoUseInRoute measure={measure} />
                                  <Divider />
                                </>
                              )}

                              {((isPc && SHOW_BANNER_CARD && props.data.length > 5 && index === 4) ||
                                (props.data.length < 5 && index == props.data.length - 1)) && (
                                <>
                                  <BannerCard />
                                  {/* <Divider /> */}
                                </>
                              )}
                            </>
                          )}
                        </div>
                      )}
                    </CellMeasurer>
                  )}
                  width={width}
                  height={height}
                  rowHeight={cacheRef.current.rowHeight}
                  overscanColumnCount={0}
                />
              </div>
            )}
          </AutoSizer>
        )}
      </WindowScroller>
    </Paper>
  );
};

export default RoutesList;
